import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { MedevacServicesBanner } from "../images";
import { ContactUsButton } from "../components/ContactUsButton/ContactUsButton";

export const MedevacServices = () => {
    const { t } = useTranslation();
    const keyFeatures = t('medevacServices.ourEndToEndMedevacProcessList', { returnObjects: true }) as string[]

    return (
        <div>
            <PageBanner image={MedevacServicesBanner} title={t('medevacServices.bannerTitle')} />

            <ContentPanel headerText={t('medevacServices.header')}>
                <p className="mb-5">{t('medevacServices.paragraph1')}</p>

                <h4 className="text-xl mb-5">{t('medevacServices.ourEndToEndMedevacProcess')}</h4>

                <UnorderedList items={keyFeatures} hasCheckmark={false} />

                <ContactUsButton title={t('medevacServices.contactUsTitle')} />
            </ContentPanel>
        </div>
    )
}